import axiosInstance from "./axiosInstance";

const billingService = {

  getTotal: async (admissionId) => {
    try {
      const response = await axiosInstance.get(`/billing/total/${admissionId}`);
      return response.data.billing;
    } catch (error) {
      throw error.response?.data ?? error;
    }
  },

  confirmDischarge: async (payload) => {
    try {
      const response = await axiosInstance.post("/billing/discharge", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data ?? error;
    }
  },


  getInvoice: async (admissionId) => {
    try {
      const response = await axiosInstance.get(`/billing/invoice/${admissionId}`);
      return response.data.invoice ?? null;
    } catch (error) {
    
      if (error.response?.status === 404) return null;
      throw error.response?.data ?? error;
    }
  },
};

export default billingService;